module.exports = __webpack_public_path__ + "static/media/DSC_0144-2.b163dd1a.jpg";